module.exports = __webpack_public_path__ + "img/cgd.2b9e3ca1.jpg";